import { Progress } from '@mantine/core';
// components
import { NumberFormatter } from '@newo/ui-kit';
// utils
import { cn } from '@/utils';

interface UnitsProgressProps {
    className?: string;
    value: number;
    min: number;
    max: number;
}

const PERCENTAGE_MULTIPLIER = 100;

const UnitsProgress = ({ value, min, max, className }: UnitsProgressProps) => {
    const percentage = (value / max) * PERCENTAGE_MULTIPLIER;
    return (
        <div className={cn('text-xs text-gray-6', className)}>
            <div className="mb-1">Units used:</div>
            <div className="relative">
                <Progress
                    color="dark"
                    radius="md"
                    size={28}
                    value={percentage}
                />
                <div className="absolute inset-0 flex items-center justify-center text-white mix-blend-difference">
                    <NumberFormatter value={value} /> /{' '}
                    <NumberFormatter value={max} />
                </div>
            </div>
            <div className="flex justify-between">
                <span>
                    <NumberFormatter value={min} />
                </span>
                <span>
                    <NumberFormatter value={max} />
                </span>
            </div>
        </div>
    );
};

export default UnitsProgress;
